import router from "@/router";
import { firebase } from "@/firebase/firebaseConfig";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import AuthService from "@/services/authService";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import Vue from "vue";
import Store from "@/store/store";

export default {
  async loginWithEnterprise({ commit }, payload) {
    const accountRes = await AiseaApiFactory.get("account").loginWithEnterprise(
      payload.loginInfo,
    );
    commit("SET_LOGIN_SUCCESS");

    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

    const fbRes = await firebase
      .auth()
      .signInWithCustomToken(accountRes.data.custom_token);

    let idToken = await fbRes.user.getIdToken();
    let refreshToken = fbRes.user.refreshToken;
    commit("SET_ID_TOKEN", { idToken: idToken });

    // FireStoreの auth_settings書き込み状況から、初回ログインか判断
    const authSettingsOnFirestore = await FireStoreService.getAccountSetting(
      "auth_settings",
    );
    const isFirstLogin =
      !authSettingsOnFirestore ||
      !Object.prototype.hasOwnProperty.call(authSettingsOnFirestore, "is_free");

    const userRes = await AiseaApiFactory.get("enterprise").fetch();
    let user = userRes.data;
    user.account_id = payload.loginInfo.id;
    user.is_first_login = isFirstLogin;
    commit("SET_USER", { user: user });

    let ids = {
      userId: null,
      enterpriseId: null,
    };

    if (payload.rememberIds) {
      ids.userId = payload.loginInfo.id;
      ids.enterpriseId = payload.loginInfo.enterprise_id;
    }

    let addons = accountRes.data.addons;
    Store.commit("SET_ADDONS", { addons: addons });

    // 有料・無料情報
    const isFree = accountRes.data.is_free;
    Store.commit("SET_IS_FREE", { isFree });

    FireStoreService.setAccountSetting("auth_settings", { is_free: isFree });

    await AuthService.saveAuthInfo({
      rememberIds: ids,
      idToken: idToken,
      refreshToken: refreshToken,
      addons: accountRes.data.addons,
      user: user,
      isFree,
      isDebug: accountRes.data.is_debug,
    });

    // FireStoreからユーザー設定を取得
    await FireStoreService.setEnterpriseAccountSettingsToLocalDb();

    Vue.$log.info("====== login Aisea ======");
    router.push({ name: "enterprise-live-map" });

    return fbRes;
  },

  async resetState({ commit }) {
    commit("RESET_STATE");
  },

  async logout({ dispatch }) {
    Vue.$log.info("====== logout Aisea ======");
    const cleanupSuccess = await dispatch("cleanupIndexedDbData").then(
      (result) => !result.some(({ status }) => status !== "fulfilled"),
    );
    if (!cleanupSuccess) {
      throw new Error("Failed to cleanup local data");
    }
    await AiseaApiFactory.get("account").logout();
    setTimeout(async () => {
      await FireStoreService.cleanupLocalData();
      dispatch("resetState"); // api リクエストによるログアウトが成功したら、state をリセット
    }, 200);
    router.push({ name: "login-enterprise" });
  },

  async cleanupIndexedDbData() {
    const result = await Promise.allSettled([LocalDbService.cleanup()]);
    return result;
  },

  // indexedDB、stateの不要なデータを削除する
  async cleanupLocalData({ dispatch }) {
    try {
      await Promise.all([
        dispatch("cleanupIndexedDbData"),
        FireStoreService.cleanupLocalData(),
      ]);
      await dispatch("resetState");
      return true;
    } catch {
      return false;
    }
  },
};
